// Title-screen soundscape: wind + distant bells + choir, procedural Web Audio.
let ac, master, timers = [], stopTimer, running = false;
let muted = localStorage.getItem("hc_menu_muted") === "1";
const VOL = 0.5;
const CHORDS = [[110, 130.81, 164.81], [87.31, 110, 130.81], [98, 116.54, 146.83], [82.41, 103.83, 123.47]];

const gain = (v = 0) => { const g = ac.createGain(); g.gain.value = v; return g; };
const filt = (type, f, q = 1) => { const n = ac.createBiquadFilter(); n.type = type; n.frequency.value = f; n.Q.value = q; return n; };
const lfo = (rate, depth, target) => { const o = ac.createOscillator(), g = gain(depth); o.frequency.value = rate; o.connect(g).connect(target); o.start(); };

function build() {
  running = true;
  ac = new (window.AudioContext || window.webkitAudioContext)();
  master = gain(0); master.connect(ac.destination);
  const verbIn = gain(1), d = ac.createDelay(2), fb = gain(0.55), lp = filt("lowpass", 1400);
  d.delayTime.value = 0.43; verbIn.connect(d).connect(lp).connect(fb).connect(d); lp.connect(master); verbIn.connect(master);

  const b = ac.createBuffer(1, ac.sampleRate * 3, ac.sampleRate), data = b.getChannelData(0);
  for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
  const n = ac.createBufferSource(); n.buffer = b; n.loop = true;
  const wbp = filt("bandpass", 420, 0.8), howl = filt("bandpass", 600, 8), wg = gain(0.32), hg = gain(0.5);
  lfo(0.09, 220, wbp.frequency); lfo(0.06, 260, howl.frequency); lfo(0.04, 0.12, wg.gain);
  n.connect(wbp).connect(wg).connect(master); n.connect(howl).connect(hg).connect(wg); n.start();

  const choir = gain(0), f1 = filt("bandpass", 700, 4), f2 = filt("bandpass", 1150, 6), cl = filt("lowpass", 1600);
  choir.connect(f1).connect(cl); choir.connect(f2).connect(cl); cl.connect(verbIn);
  const voices = [0, 1, 2].flatMap((k) => [-6, 6].map((det) => {
    const o = ac.createOscillator(); o.type = "sawtooth"; o.detune.value = det; o.frequency.value = CHORDS[0][k]; o.connect(choir); o.start(); lfo(4.6 + k * 0.3, 3, o.detune); return [o, k];
  }));
  let ci = 0;
  const swell = () => {
    if (!running) return;
    const t = ac.currentTime, ch = CHORDS[ci++ % CHORDS.length];
    voices.forEach(([o, k]) => o.frequency.setTargetAtTime(ch[k], t, 1.2));
    choir.gain.cancelScheduledValues(t); choir.gain.setTargetAtTime(0.09, t, 2.2); choir.gain.setTargetAtTime(0.025, t + 6, 2.5);
  };
  swell(); timers.push(setInterval(swell, 11000));

  const bell = () => {
    if (!running) return;
    const t = ac.currentTime, base = [146.83, 130.81, 110][Math.floor(Math.random() * 3)];
    [[1, 0.22], [2, 0.1], [2.4, 0.08], [3, 0.05], [4.2, 0.03], [0.5, 0.12]].forEach(([r, v]) => {
      const o = ac.createOscillator(), g = gain(0); o.frequency.value = base * r; o.connect(g).connect(verbIn);
      g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(v, t + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + 6 / r + 1);
      o.start(t); o.stop(t + 7.5);
    });
  };
  timers.push(setTimeout(bell, 1500), setInterval(bell, 8000));
}

export function startMenuMusic() {
  clearTimeout(stopTimer);
  if (!ac) build();
  ac.resume(); running = true;
  master.gain.setTargetAtTime(muted ? 0 : VOL, ac.currentTime, 1.2);
}

export function stopMenuMusic() {
  running = false;
  if (!ac) return;
  master.gain.setTargetAtTime(0, ac.currentTime, 0.4);
  stopTimer = setTimeout(() => !running && ac.suspend(), 1800);
}

export const isMenuMuted = () => muted;
export function setMenuMuted(m) {
  muted = m; localStorage.setItem("hc_menu_muted", m ? "1" : "0");
  if (ac && running) master.gain.setTargetAtTime(m ? 0 : VOL, ac.currentTime, 0.3);
}
